//#region Imports

import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { getAppVersion } from '../../utils/app-version.util';

//#endregion

interface FooterLink {
  label: string;
  route: string;
}

@Component({
  selector: 'l-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [CommonModule, RouterLink]
})
export class FooterComponent {
  
  //#region Properties

  public navLinks: FooterLink[] = [
    { label: 'HOME', route: '/' },
    { label: 'MEUS CURSOS', route: '/courses' },
    { label: 'TRILHAS', route: '/trilhas' }
  ];

  public readonly appVersion: string = getAppVersion();

  //#endregion
}
